import { backendAxios } from "../Services/axios";

export default class SwipeController {
  static async requestStay(payload: any) {
    const response = await backendAxios.post("stay-request", { payload });
    return response.data;
  }
}
